import { ScrollView } from 'devextreme-react/scroll-view';
import React, { useRef } from 'react';
import './side-nav-outer-toolbar.scss';




export default function SideNavOuterToolbar({children }) {
  const scrollViewRef = useRef(null);

  return (
    <div className={'side-nav-outer-toolbar'}>
        <div className={'container'}>
          <ScrollView ref={scrollViewRef} className={'layout-body with-footer'}>
            <div className={'content'}>
              {React.Children.map(children, (item) => {
                return item;
              })}
            </div>
          </ScrollView>
        </div>
    </div>
  );
}
